<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>
    Sie waren bei mindestens einem Facharzt für die Beckenregion (Urologe, Gynäkologe, Proktologe,
    …) und dieser hat trotz eingehender Untersuchung keine Ursache für Ihre Beschwerden gefunden?
  </p>
</QuestionFrame>
